import { Link } from "react-router-dom";
import { CalendarClock, ChevronRight } from "lucide-react";
import { STATUS, fmtDate, vehicleLabel } from "@/lib/api";

export function StatusBadge({ status, testid }) {
  const s = STATUS[status] || STATUS.in_coda;
  return (
    <span className={`st ${s.cls} inline-flex items-center gap-1.5`} data-testid={testid || "ticket-status-badge"}>
      {status === "in_lavorazione" && <span className="live-dot" />}
      {s.label}
    </span>
  );
}

export function TicketCard({ t, showClient }) {
  return (
    <Link
      to={`/ticket/${t.id}`}
      data-testid={`ticket-card-${t.number}`}
      className="surface p-4 sm:p-5 flex items-center gap-4 hover:border-[#E50914]/60 transition-colors group fade-up"
    >
      <div className="mono text-[#E50914] font-bold text-lg w-14 shrink-0">#{t.number}</div>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-2 mb-1">
          <span className="font-semibold text-white truncate">{vehicleLabel(t.vehicle)}</span>
          {t.vehicle.plate && <span className="tag">{t.vehicle.plate}</span>}
          <StatusBadge status={t.status} testid={`ticket-status-${t.number}`} />
        </div>
        <div className="text-sm text-slate-400 flex flex-wrap gap-x-4 gap-y-1">
          <span className="flex items-center gap-1.5">
            <CalendarClock size={14} /> {fmtDate(t.slot_date, { day: "2-digit", month: "short", year: "numeric" })} · {t.slot_time}
          </span>
          {showClient && <span className="text-slate-300">{t.client_name}</span>}
          {t.dtc_codes?.length > 0 && <span className="mono text-xs">{t.dtc_codes.slice(0, 3).join(" · ")}</span>}
        </div>
      </div>
      <ChevronRight className="text-slate-600 group-hover:text-[#E50914] transition-colors shrink-0" size={20} />
    </Link>
  );
}
